export default {"src":"/_next/static/media/video_camera_front.f2ca6772.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};